import styled from 'styled-components';
import { Button } from '../utils/Button/Button';
import { Text14Light } from '../utils/Text/Text.styles';
import Skeleton from 'react-loading-skeleton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2.4rem;
  height: 100%;
`;

export const Header = styled.div`
  padding: 1.4rem 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderText = styled(Text14Light)`
  opacity: 0.4;
`;

export const StyledButton = styled(Button)`
  width: 35rem;
  margin-top: 1rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
  }
`;

export const NumberOfPhotos = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const Form = styled.form`
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 3rem;
  width: 100%;
`;

export const BackIconWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 0;
`;

export const Content = styled.div`
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
  margin-bottom: 1.6rem;
  padding: 0.1rem;
  align-content: baseline;
  width: 100%;
`;

export const SkeletonContainer = styled(Skeleton)`
  width: 12rem;
  height: 11.75rem;
  border-radius: 8px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e7eb;
  margin-top: 1.6rem;
`;

export const EmptyDiv = styled.div`
  height: 12rem;

  @media only screen and (max-width: 500px) {
    height: 24.2rem;
  }
`;
